import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Vue from 'vue';
import Vuex from 'vuex';
import Meta from 'vue-meta';
import ClientOnly from 'vue-client-only';
import NoSsr from 'vue-no-ssr';
import { createRouter } from './router.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtError from '../layouts/error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData, normalizeError } from './utils';
import { createStore } from './store.js';
/* Plugins */

import nuxt_plugin_vuescrollto_6fbcfba5 from 'nuxt_plugin_vuescrollto_6fbcfba5'; // Source: ./vue-scrollto.js (mode: 'client')

import nuxt_plugin_cookieuniversalnuxt_2e778ce8 from 'nuxt_plugin_cookieuniversalnuxt_2e778ce8'; // Source: ./cookie-universal-nuxt.js (mode: 'all')

import nuxt_plugin_recaptcha_d438435a from 'nuxt_plugin_recaptcha_d438435a'; // Source: ./recaptcha.js (mode: 'all')

import nuxt_plugin_nuxtcustomheadersmiddleware3e6f330a_3a3410f6 from 'nuxt_plugin_nuxtcustomheadersmiddleware3e6f330a_3a3410f6'; // Source: ./nuxt-custom-headers.middleware.3e6f330a.js (mode: 'all')

import nuxt_plugin_apollomodule_212789b0 from 'nuxt_plugin_apollomodule_212789b0'; // Source: ./apollo-module.js (mode: 'all')

import nuxt_plugin_axios_5462e1e4 from 'nuxt_plugin_axios_5462e1e4'; // Source: ./axios.js (mode: 'all')

import nuxt_plugin_webfontloader_ebb3f838 from 'nuxt_plugin_webfontloader_ebb3f838'; // Source: ./webfontloader.js (mode: 'client')

import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80'; // Source: ../plugins/axios (mode: 'all')

import nuxt_plugin_lazysizes_63bafee8 from 'nuxt_plugin_lazysizes_63bafee8'; // Source: ../plugins/lazysizes (mode: 'client')

import nuxt_plugin_vuecarousel_6c010c3d from 'nuxt_plugin_vuecarousel_6c010c3d'; // Source: ../plugins/vue-carousel (mode: 'client')

import nuxt_plugin_smoothscroll_68d9071e from 'nuxt_plugin_smoothscroll_68d9071e'; // Source: ../plugins/smoothscroll (mode: 'client')

import nuxt_plugin_vue2touchevents_0aa7791c from 'nuxt_plugin_vue2touchevents_0aa7791c'; // Source: ../plugins/vue2-touch-events (mode: 'client')

import nuxt_plugin_routenavigation_72364ba9 from 'nuxt_plugin_routenavigation_72364ba9'; // Source: ../plugins/route-navigation.js (mode: 'client')

import nuxt_plugin_globalmixins_415d51c6 from 'nuxt_plugin_globalmixins_415d51c6'; // Source: ../plugins/global-mixins (mode: 'all')

import nuxt_plugin_mdmicon_d6dbc0b4 from 'nuxt_plugin_mdmicon_d6dbc0b4'; // Source: ../plugins/mdm-icon (mode: 'all')

import nuxt_plugin_vuei18n_9dc1c90a from 'nuxt_plugin_vuei18n_9dc1c90a'; // Source: ../plugins/vue-i18n (mode: 'all')

import nuxt_plugin_logplugin_7f46fc5c from 'nuxt_plugin_logplugin_7f46fc5c'; // Source: ../plugins/log-plugin (mode: 'all')
// Component: <ClientOnly>

Vue.component(ClientOnly.name, ClientOnly); // TODO: Remove in Nuxt 3: <NoSsr>

Vue.component(NoSsr.name, _objectSpread(_objectSpread({}, NoSsr), {}, {
  render(h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true;
      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead');
    }

    return NoSsr.render(h, ctx);
  }

})); // Component: <NuxtChild>

Vue.component(NuxtChild.name, NuxtChild);
Vue.component('NChild', NuxtChild); // Component NuxtLink is imported in server.js or client.js
// Component: <Nuxt>

Vue.component(Nuxt.name, Nuxt);
Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt;
  },

  configurable: true
});
Vue.use(Meta, {
  "keyName": "head",
  "attribute": "data-n-head",
  "ssrAttribute": "data-n-head-ssr",
  "tagIDKeyName": "hid"
});
var defaultTransition = {
  "name": "page",
  "mode": "",
  "appear": false,
  "appearClass": "appear",
  "appearActiveClass": "appear-active",
  "appearToClass": "appear-to"
};
var originalRegisterModule = Vuex.Store.prototype.registerModule;
var baseStoreOptions = {
  preserveState: process.client
};

function registerModule(path, rawModule) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return originalRegisterModule.call(this, path, rawModule, _objectSpread(_objectSpread({}, baseStoreOptions), options));
}

function createApp(_x) {
  return _createApp.apply(this, arguments);
}

function _createApp() {
  _createApp = _asyncToGenerator(function* (ssrContext) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var router = yield createRouter(ssrContext);
    var store = createStore(ssrContext); // Add this.$router into store actions/mutations

    store.$router = router; // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141

    store.registerModule = registerModule; // Create Root instance
    // here we inject the router and store to all child components,
    // making them available everywhere as `this.$router` and `this.$store`.

    var app = _objectSpread({
      head: {
        "meta": [{
          "charset": "utf-8"
        }, {
          "name": "viewport",
          "content": "width=device-width, initial-scale=1, shrink-to-fit=no"
        }, {
          "http-equiv": "X-UA-Compatible",
          "content": "IE=edge,chrome=1"
        }, {
          "name": "p:domain_verify",
          "content": "0a86043d31b2dcce2b434e0b5f7c3339"
        }, {
          "name": "p:domain_verify",
          "content": "7158fe360cf1d00c8dcdfdeb29350a66"
        }, {
          "name": "p:domain_verify",
          "content": "770dc96158af95fed9bd7279044ad861"
        }, {
          "name": "p:domain_verify",
          "content": "c5ad649b56c6ecda0ca2c1f504119db1"
        }],
        "link": [{
          "rel": "icon",
          "type": "image\u002Fx-icon",
          "href": "\u002Ffavicon.ico"
        }],
        "style": [],
        "script": []
      },
      store,
      router,
      nuxt: {
        defaultTransition,
        transitions: [defaultTransition],

        setTransitions(transitions) {
          if (!Array.isArray(transitions)) {
            transitions = [transitions];
          }

          transitions = transitions.map(transition => {
            if (!transition) {
              transition = defaultTransition;
            } else if (typeof transition === 'string') {
              transition = Object.assign({}, defaultTransition, {
                name: transition
              });
            } else {
              transition = Object.assign({}, defaultTransition, transition);
            }

            return transition;
          });
          this.$options.nuxt.transitions = transitions;
          return transitions;
        },

        err: null,
        dateErr: null,

        error(err) {
          err = err || null;
          app.context._errored = Boolean(err);
          err = err ? normalizeError(err) : null;
          var nuxt = app.nuxt; // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207

          if (this) {
            nuxt = this.nuxt || this.$options.nuxt;
          }

          nuxt.dateErr = Date.now();
          nuxt.err = err; // Used in src/server.js

          if (ssrContext) {
            ssrContext.nuxt.error = err;
          }

          return err;
        }

      }
    }, App); // Make app available into store via this.app


    store.app = app;
    var next = ssrContext ? ssrContext.next : location => app.router.push(location); // Resolve route

    var route;

    if (ssrContext) {
      route = router.resolve(ssrContext.url).route;
    } else {
      var path = getLocation(router.options.base, router.options.mode);
      route = router.resolve(path).route;
    } // Set context to app.context


    yield setContext(app, {
      store,
      route,
      next,
      error: app.nuxt.error.bind(app),
      payload: ssrContext ? ssrContext.payload : undefined,
      req: ssrContext ? ssrContext.req : undefined,
      res: ssrContext ? ssrContext.res : undefined,
      beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
      ssrContext
    });

    function inject(key, value) {
      if (!key) {
        throw new Error('inject(key, value) has no key provided');
      }

      if (value === undefined) {
        throw new Error("inject('".concat(key, "', value) has no value provided"));
      }

      key = '$' + key; // Add into app

      app[key] = value; // Add into context

      if (!app.context[key]) {
        app.context[key] = value;
      } // Add into store


      store[key] = app[key]; // Check if plugin not already installed

      var installKey = '__nuxt_' + key + '_installed__';

      if (Vue[installKey]) {
        return;
      }

      Vue[installKey] = true; // Call Vue.use() to install the plugin into vm

      Vue.use(() => {
        if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
          Object.defineProperty(Vue.prototype, key, {
            get() {
              return this.$root.$options[key];
            }

          });
        }
      });
    } // Inject runtime config as $config


    inject('config', config);

    if (process.client) {
      // Replace store state before plugins execution
      if (window.__NUXT__ && window.__NUXT__.state) {
        store.replaceState(window.__NUXT__.state);
      }
    } // Add enablePreview(previewData = {}) in context for plugins


    if (process.static && process.client) {
      app.context.enablePreview = function () {
        var previewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        app.previewData = Object.assign({}, previewData);
        inject('preview', previewData);
      };
    } // Plugin execution


    if (process.client && typeof nuxt_plugin_vuescrollto_6fbcfba5 === 'function') {
      yield nuxt_plugin_vuescrollto_6fbcfba5(app.context, inject);
    }

    if (typeof nuxt_plugin_cookieuniversalnuxt_2e778ce8 === 'function') {
      yield nuxt_plugin_cookieuniversalnuxt_2e778ce8(app.context, inject);
    }

    if (typeof nuxt_plugin_recaptcha_d438435a === 'function') {
      yield nuxt_plugin_recaptcha_d438435a(app.context, inject);
    }

    if (typeof nuxt_plugin_nuxtcustomheadersmiddleware3e6f330a_3a3410f6 === 'function') {
      yield nuxt_plugin_nuxtcustomheadersmiddleware3e6f330a_3a3410f6(app.context, inject);
    }

    if (typeof nuxt_plugin_apollomodule_212789b0 === 'function') {
      yield nuxt_plugin_apollomodule_212789b0(app.context, inject);
    }

    if (typeof nuxt_plugin_axios_5462e1e4 === 'function') {
      yield nuxt_plugin_axios_5462e1e4(app.context, inject);
    }

    if (process.client && typeof nuxt_plugin_webfontloader_ebb3f838 === 'function') {
      yield nuxt_plugin_webfontloader_ebb3f838(app.context, inject);
    }

    if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
      yield nuxt_plugin_axios_3566aa80(app.context, inject);
    }

    if (process.client && typeof nuxt_plugin_lazysizes_63bafee8 === 'function') {
      yield nuxt_plugin_lazysizes_63bafee8(app.context, inject);
    }

    if (process.client && typeof nuxt_plugin_vuecarousel_6c010c3d === 'function') {
      yield nuxt_plugin_vuecarousel_6c010c3d(app.context, inject);
    }

    if (process.client && typeof nuxt_plugin_smoothscroll_68d9071e === 'function') {
      yield nuxt_plugin_smoothscroll_68d9071e(app.context, inject);
    }

    if (process.client && typeof nuxt_plugin_vue2touchevents_0aa7791c === 'function') {
      yield nuxt_plugin_vue2touchevents_0aa7791c(app.context, inject);
    }

    if (process.client && typeof nuxt_plugin_routenavigation_72364ba9 === 'function') {
      yield nuxt_plugin_routenavigation_72364ba9(app.context, inject);
    }

    if (typeof nuxt_plugin_globalmixins_415d51c6 === 'function') {
      yield nuxt_plugin_globalmixins_415d51c6(app.context, inject);
    }

    if (typeof nuxt_plugin_mdmicon_d6dbc0b4 === 'function') {
      yield nuxt_plugin_mdmicon_d6dbc0b4(app.context, inject);
    }

    if (typeof nuxt_plugin_vuei18n_9dc1c90a === 'function') {
      yield nuxt_plugin_vuei18n_9dc1c90a(app.context, inject);
    }

    if (typeof nuxt_plugin_logplugin_7f46fc5c === 'function') {
      yield nuxt_plugin_logplugin_7f46fc5c(app.context, inject);
    } // Lock enablePreview in context


    if (process.static && process.client) {
      app.context.enablePreview = function () {
        console.warn('You cannot call enablePreview() outside a plugin.');
      };
    } // If server-side, wait for async component to be resolved first


    if (process.server && ssrContext && ssrContext.url) {
      yield new Promise((resolve, reject) => {
        router.push(ssrContext.url, resolve, err => {
          // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
          if (!err._isRouter) return reject(err);
          if (err.type !== 2
          /* NavigationFailureType.redirected */
          ) return resolve(); // navigated to a different route in router guard

          var unregister = router.afterEach( /*#__PURE__*/function () {
            var _ref = _asyncToGenerator(function* (to, from) {
              ssrContext.url = to.fullPath;
              app.context.route = yield getRouteData(to);
              app.context.params = to.params || {};
              app.context.query = to.query || {};
              unregister();
              resolve();
            });

            return function (_x2, _x3) {
              return _ref.apply(this, arguments);
            };
          }());
        });
      });
    }

    return {
      store,
      app,
      router
    };
  });
  return _createApp.apply(this, arguments);
}

export { createApp, NuxtError };